// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_contract.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { BrowseRegistryContractsRequest, BrowseRegistryContractsResponse, CreateRegistryContractRequest, CreateRegistryContractResponse, GetRegistryContractObservationRequest, GetRegistryContractObservationResponse, GetRegistryContractRequest, GetRegistryContractResponse, ListContactConnectedWorkRequest, ListContactConnectedWorkResponse, ListLandscapeProgramReferencesRequest, ListLandscapeProgramReferencesResponse, ListProgramFollowOnOptionsRequest, ListProgramFollowOnOptionsResponse, ListRegistryContractEvidenceRequest, ListRegistryContractEvidenceResponse, ListRegistryContractObservationsRequest, ListRegistryContractObservationsResponse, ResolveRegistryContractFactRequest, ResolveRegistryContractFactResponse, SaveProgramFollowOnRequest, SaveProgramFollowOnResponse, UpdateRegistryContractRefsRequest, UpdateRegistryContractRefsResponse, WriteRegistryContractFactRequest, WriteRegistryContractFactResponse } from "./registry_contract_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { GetAwardSignalRequest, GetAwardSignalResponse, OpenAwardFollowOnRequest, OpenAwardFollowOnResponse, UpdateAwardSignalHypothesisRequest, UpdateAwardSignalHypothesisResponse } from "./opportunity_signal_pb";
import { ArchiveVehicleRelationshipRequest, ArchiveVehicleRelationshipResponse, BrowseVehiclesRequest, BrowseVehiclesResponse, GetVehicleProfileRequest, GetVehicleProfileResponse, ListVehicleConnectionsRequest, ListVehicleConnectionsResponse, ListVehicleRelationshipsRequest, ListVehicleRelationshipsResponse, SaveVehicleProfileRequest, SaveVehicleProfileResponse, SaveVehicleRelationshipRequest, SaveVehicleRelationshipResponse } from "./vehicle_identity_pb";
/**
 * Browser service. Tenant and actor come exclusively from the gateway principal.
 * Read all pages until next_after_id is empty; detail contains no implicit evidence page.
 *
 * @generated from service mono.datagateway.v1.RegistryContractService
 */ export const RegistryContractService = {
    typeName: "mono.datagateway.v1.RegistryContractService",
    methods: {
        /**
     * Deliberate Program publication reuse; never opens a Pursuit or Notice.
     *
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListProgramFollowOnOptions
     */ listProgramFollowOnOptions: {
            name: "ListProgramFollowOnOptions",
            I: ListProgramFollowOnOptionsRequest,
            O: ListProgramFollowOnOptionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.SaveProgramFollowOn
     */ saveProgramFollowOn: {
            name: "SaveProgramFollowOn",
            I: SaveProgramFollowOnRequest,
            O: SaveProgramFollowOnResponse,
            kind: MethodKind.Unary
        },
        /**
     * Released Program context; a Landscape link confers no Delivery authority.
     *
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListLandscapeProgramReferences
     */ listLandscapeProgramReferences: {
            name: "ListLandscapeProgramReferences",
            I: ListLandscapeProgramReferencesRequest,
            O: ListLandscapeProgramReferencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Bounded registry traversal. Each connected context is independently
     * resolver-authorized; the response contains no hidden totals or notes.
     *
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListContactConnectedWork
     */ listContactConnectedWork: {
            name: "ListContactConnectedWork",
            I: ListContactConnectedWorkRequest,
            O: ListContactConnectedWorkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.OpenAwardFollowOn
     */ openAwardFollowOn: {
            name: "OpenAwardFollowOn",
            I: OpenAwardFollowOnRequest,
            O: OpenAwardFollowOnResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.GetAwardSignal
     */ getAwardSignal: {
            name: "GetAwardSignal",
            I: GetAwardSignalRequest,
            O: GetAwardSignalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.UpdateAwardSignalHypothesis
     */ updateAwardSignalHypothesis: {
            name: "UpdateAwardSignalHypothesis",
            I: UpdateAwardSignalHypothesisRequest,
            O: UpdateAwardSignalHypothesisResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.BrowseRegistryContracts
     */ browseRegistryContracts: {
            name: "BrowseRegistryContracts",
            I: BrowseRegistryContractsRequest,
            O: BrowseRegistryContractsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.GetRegistryContract
     */ getRegistryContract: {
            name: "GetRegistryContract",
            I: GetRegistryContractRequest,
            O: GetRegistryContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.CreateRegistryContract
     */ createRegistryContract: {
            name: "CreateRegistryContract",
            I: CreateRegistryContractRequest,
            O: CreateRegistryContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.UpdateRegistryContractRefs
     */ updateRegistryContractRefs: {
            name: "UpdateRegistryContractRefs",
            I: UpdateRegistryContractRefsRequest,
            O: UpdateRegistryContractRefsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListRegistryContractEvidence
     */ listRegistryContractEvidence: {
            name: "ListRegistryContractEvidence",
            I: ListRegistryContractEvidenceRequest,
            O: ListRegistryContractEvidenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.GetRegistryContractObservation
     */ getRegistryContractObservation: {
            name: "GetRegistryContractObservation",
            I: GetRegistryContractObservationRequest,
            O: GetRegistryContractObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListRegistryContractObservations
     */ listRegistryContractObservations: {
            name: "ListRegistryContractObservations",
            I: ListRegistryContractObservationsRequest,
            O: ListRegistryContractObservationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ResolveRegistryContractFact
     */ resolveRegistryContractFact: {
            name: "ResolveRegistryContractFact",
            I: ResolveRegistryContractFactRequest,
            O: ResolveRegistryContractFactResponse,
            kind: MethodKind.Unary
        },
        /**
     * Appends a private reviewed fact and its evidence in one transaction. A new
     * retry_key is required for a new decision, including committing a proposal.
     * Browser clients cannot ingest public or held-document originals.
     *
     * @generated from rpc mono.datagateway.v1.RegistryContractService.WriteRegistryContractFact
     */ writeRegistryContractFact: {
            name: "WriteRegistryContractFact",
            I: WriteRegistryContractFactRequest,
            O: WriteRegistryContractFactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.BrowseVehicles
     */ browseVehicles: {
            name: "BrowseVehicles",
            I: BrowseVehiclesRequest,
            O: BrowseVehiclesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.GetVehicleProfile
     */ getVehicleProfile: {
            name: "GetVehicleProfile",
            I: GetVehicleProfileRequest,
            O: GetVehicleProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.SaveVehicleProfile
     */ saveVehicleProfile: {
            name: "SaveVehicleProfile",
            I: SaveVehicleProfileRequest,
            O: SaveVehicleProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListVehicleRelationships
     */ listVehicleRelationships: {
            name: "ListVehicleRelationships",
            I: ListVehicleRelationshipsRequest,
            O: ListVehicleRelationshipsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.SaveVehicleRelationship
     */ saveVehicleRelationship: {
            name: "SaveVehicleRelationship",
            I: SaveVehicleRelationshipRequest,
            O: SaveVehicleRelationshipResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ArchiveVehicleRelationship
     */ archiveVehicleRelationship: {
            name: "ArchiveVehicleRelationship",
            I: ArchiveVehicleRelationshipRequest,
            O: ArchiveVehicleRelationshipResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryContractService.ListVehicleConnections
     */ listVehicleConnections: {
            name: "ListVehicleConnections",
            I: ListVehicleConnectionsRequest,
            O: ListVehicleConnectionsResponse,
            kind: MethodKind.Unary
        }
    }
};
